// extracted by mini-css-extract-plugin
export var authorIntroduction = "index-module--authorIntroduction--EeueV";
export var content = "index-module--content--fuDgT";
export var darkColor = "index-module--darkColor--HPrPJ";